module.exports = __webpack_public_path__ + "static/media/v-ambientworks.091396e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/v-ambientworks.mp3
// module id = gQiV
// module chunks = 0